export default {
    user: null,
    access_token: null,
    team: null,
}
